import React from 'react';
import { FormattedMessage } from 'react-intl';
import { END_OF_DAY_VIEW_ID } from './view-id-constants';

export const EndOfDay = {
  label: (
    <FormattedMessage defaultMessage='Manifests' description='Left nav link text for Manifests under the End of Day category' id='QvE0Jf' />
  ),

  id: END_OF_DAY_VIEW_ID,
};
